import React from "react";
import {animated} from "react-spring";

export class CTF extends React.Component {
    render() {
        return <section id="ctf" style={{marginTop: "50px"}}>
            <animated.div style={this.props.style} className="container">
                <div className="section-header">
                    <h2>Capture The Flag</h2>
                </div>
                <div className="row" style={{marginBottom: "50px"}}>
                    <div className="col">
                        The CTF details will be mailed to you close to the event in 2022 to the email used for registration. <br/>
                        The CTF is limited to ticket holders.
                    </div>
                </div>
            </animated.div>
        </section>;
    }
}
